import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ContentSections from './components/ContentSections';
import ArticlesSection from './components/ArticlesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ContentSections />
        <ArticlesSection />
      </main>
      <Footer />
    </div>
  );
}